import { useCallback, useEffect, useState } from "react";
import { useDialogs } from "../hooks/use-dialogs";
import useUsersModel, { NewUserData } from "../model/users";
import { ManagedUser } from "../types/general";
import { getErrorMessage } from "../utils/errors";

export const ViewModelUsers = () => {
  const model = useUsersModel();
  const { dialog, close, showConfirmation, showSuccess, showError } = useDialogs();

  const [users, setUsers] = useState<ManagedUser[]>([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalData: 0 });
  const [loading, setLoading] = useState(false);

  const fail = (error: any, fallback: string) =>
    showError({ title: "Erro", message: getErrorMessage(error, fallback) });

  const fetchUsers = useCallback(async (page = 1) => {
    try {
      const result = await model.fetchUsers(page);
      setUsers(result.data);
      setPagination({ ...result.pagination, totalData: result.totalData });
    } catch (error) {
      fail(error, "Não foi possível carregar os utilizadores.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Devolve true quando o utilizador foi criado
  const createUser = async (data: NewUserData) => {
    setLoading(true);
    try {
      await model.createUser(data);
      await fetchUsers(1);
      showSuccess({
        title: "Sucesso",
        message: "Utilizador criado. A conta fica pendente com a senha padrão 000000 até o utilizador confirmar o código e definir uma nova senha.",
      });
      return true;
    } catch (error) {
      fail(error, "Ocorreu um erro ao criar o utilizador.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (target: ManagedUser) => {
    showConfirmation({
      title: "Confirmar Remoção",
      message: `Tem a certeza que deseja remover "${target.name}"? Esta ação não pode ser desfeita.`,
      onConfirm: async () => {
        close();
        try {
          await model.deleteUser(target.id);
          // Se era o único da página, recua uma página
          const page = users.length === 1 ? Math.max(1, pagination.currentPage - 1) : pagination.currentPage;
          await fetchUsers(page);
          showSuccess({ title: "Sucesso", message: "Utilizador removido com sucesso!" });
        } catch (error) {
          fail(error, "Ocorreu um erro ao remover o utilizador.");
        }
      },
    });
  };

  return {
    users,
    pagination,
    loading,
    dialog,
    fetchUsers,
    createUser,
    confirmDelete,
  };
};
